import React from 'react'
import gql from 'graphql-tag'
import { createContext } from 'labguard-cdk'
import { useChannelId, useZoom } from 'src/hooks'
import { useQuery } from 'react-apollo'

const query = gql`
  query channelSterilization($channelId: ID!, $period: PeriodInput!, $input: SterilizationInput!) {
    channel(id: $channelId) {
      id
      sterilization(period: $period, input: $input) {
        equivalent
        durationOver
        totalDuration
        testVerdict
        validationTime
        durationOnValidation
        chartData {
          date
          value
        }
      }
    }
  }
`

export default createContext(
  Provider =>
    function SterilizationContext(props) {
      // retrieve channel id from route params
      const channelId = useChannelId()

      // retrieve zoom
      const [from, to] = useZoom()

      // create local state
      const [value, onChange] = React.useState()

      // retrieve result
      const { loading, data: { channel: { sterilization: result } = {} } = {} } = useQuery(query, {
        skip: !value,
        variables: {
          channelId,
          period: { from, to },
          input: value,
        },
        context: { debounce: true },
      })

      // return Provider with its value
      return (
        <Provider
          value={{
            value,
            onChange,
            loading,
            result: result || undefined,
          }}
          {...props}
        />
      )
    },
  {}
)
